import { render, staticRenderFns } from "./NumberOfStorey.vue?vue&type=template&id=3fb84325"
import script from "./NumberOfStorey.vue?vue&type=script&lang=js"
export * from "./NumberOfStorey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports